import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { twitterShareUrl, facebookShareUrl } from '@/lib/url'
import { FacebookIcon, TwitterIcon } from '@/components/atoms/SocialIcon'

type Props = {
  url: string
  title: string
  theme?: 'light-bg' | 'dark-bg'
}

export const ShareMenu: React.FC<Props> = ({
  theme = 'light-bg',
  ...props
}) => {
  const color = theme === 'light-bg' ? colors.textStrong : colors.white00

  return (
    <div
      css={css`
        align-self: flex-end;
        display: flex;
        align-items: center;
      `}
      className="share-page"
    >
      <span
        css={css`
          font-size: 13px;
          line-height: 1.5;
          color: ${color};
          margin-right: 10px;
        `}
      >
        このページをシェア
      </span>
      <HoverEffectLink
        href={twitterShareUrl(props.url, props.title)}
        hoverColor={colors.twitter}
      >
        <TwitterIcon
          size={22}
          css={css`
            color: ${color};
          `}
        />
      </HoverEffectLink>
      <HoverEffectLink
        href={facebookShareUrl(props.url)}
        hoverColor={colors.facebook}
      >
        <FacebookIcon
          size={22}
          css={css`
            color: ${color};
          `}
        />
      </HoverEffectLink>
    </div>
  )
}

type HoverEffectLinkProps = {
  href: string
  hoverColor: string
  children: React.ReactNode
}

const HoverEffectLink: React.FC<HoverEffectLinkProps> = (props) => {
  return (
    <a
      href={props.href}
      css={css`
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;

        &,
        i {
          transition: 0.3s;
        }

        &:hover {
          background-color: ${props.hoverColor};
          i {
            color: ${colors.white00};
          }
        }
      `}
      target="_blank"
      rel="noopener noreferrer"
      suppressHydrationWarning
    >
      {props.children}
    </a>
  )
}
